import React, { useMemo } from 'react';

import ClubLayout from 'app/layouts/ClubLayout';
import PublicLayout from 'app/layouts/PublicLayout';
import HomeLayout from 'app/layouts/HomeLayout';
import AuthLayout from 'app/layouts/AuthLayout';
import OnboardLayout from 'app/layouts/OnboardLayout';
import RestrictedLayout from 'app/layouts/RestrictedLayout';

import useApp from 'app/context/useApp';

export default function AppLayout(props) {

    const { app } = useApp();

    const { appLoading } = props;

    return useMemo(() => {
        if (appLoading) return null;
        if (! app.user && app.club) return <PublicLayout />; // Not authenticated and club has public pages
        if (! app.user) return <AuthLayout />; // Not authenticated
        if (Boolean(app.user.restricted_at)) return <RestrictedLayout />; // User's account has been restricted
        if (! app.club) return <HomeLayout />;
        if (app.user.association === null) return <AuthLayout />; // Not associated
        if (! app.user.agreed_to_terms) return <OnboardLayout />

        const a = app.user.association.meta;

        if (a && a.onboard_message) return <OnboardLayout />
        if (a && a.onboard_password) return <OnboardLayout />
        if (a && a.onboard_profile) return <OnboardLayout />
        if (a && a.onboard_membership) return <OnboardLayout />
        if (a && a.onboard_membership_invoice && app.user.membership_status.invoice) return <OnboardLayout />

        return <ClubLayout />;

    }, [app, appLoading]);
}
